import { useMutation } from '@tanstack/react-query'
import defaultConfig from 'const/config'
import {
  CompleteMutationResult,
  CompleteUseMutationProps
} from './completeMutation.types'
import { getCompleteOptions } from './completeMutationOptions'

const defaultOptions = { config: defaultConfig }
/**
 * Calls /complete which finishes authentication and gets ready state of authorization.
 * This notifies OAuth State Manager service that user is authenticated and app is ready for authorization.
 * https://developer.syf.com/internal-api-reference/credit-accounts-identity-v1#operation/Complete%20Authenticate
 * @param props @see {@link CompleteUseMutationProps} - options for the complete query
 * @returns the same as useMutation returns, an obj with .data and other query stuff
 */
const useCompleteMutation = ({
  config = defaultConfig,
  mutationOptions = {}
}: CompleteUseMutationProps = defaultOptions): CompleteMutationResult => {
  const completeMutationOptions = getCompleteOptions({
    config,
    mutationOptions
  })

  return useMutation(completeMutationOptions)
}

export default useCompleteMutation
